export default __webpack_public_path__ + "static/media/FK.79d7f859.svg";